export const CATEGORY_COLOR_MAP = [
  '#348EF6',
  '#FFA826',
  '#33C173',
  '#7F58F0',
  '#FD5CAD',
  '#B669BF',
  '#124345',
  '#373421',
]

export const CATEGORY_BACKGROUND_COLOR_MAP = [
  '#ECF4FE',
  '#FFF7EA',
  '#EBF9F1',
  '#F1F0F9',
  '#FFF5FA',
  '#F4F1F5',
  '#F3F9F9',
  '#FFFCE5',
]

export const CATEGORY_ANNOTATION_MAP = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
]

export const CATEGORY_ANNOTATION_COLOR_MAP = [
  '#1162C0',
  '#A35F21',
  '#0A8041',
  '#6445BD',
  '#CC4A8B',
  '#794680',
  '#124345',
  '#373421',
]

export const CATEGORY_NAME_LENGTH = 40
export const CATEGORY_OPTION_LENGTH = 96
